import type { Deal } from "@/lib/types/database/deals";
import { ENHANCED_DEALS_CONFIG } from "@/features/deals/components/EnhancedDealsConfig";
import { ENHANCED_DEAL_DETAIL_CONFIG } from "@/features/deals/components/DealDetailConfig";
import { useDealsTagsConfigEnhancer } from "@/lib/hooks/api/shared/config-enhancers";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// DEALS ENTITY DEFINITION
// ============================================================================
// Single source of truth for all deals UI configuration.
// Column change: edit tableConfig.fields (features/deals/config/deal-fields-core.ts).
// New saved view: edit features/deals/config/deal-saved-views.ts.
// ============================================================================

export const dealsEntity = defineEntity<Deal>({
  tableConfig: ENHANCED_DEALS_CONFIG,

  detailConfig: ENHANCED_DEAL_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Injects dynamic tag options into fields at render time
  useConfigEnhancer: (config) => useDealsTagsConfigEnhancer({ config }),
});
